export enum GroupingInterval {
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
}

export enum MembershipModel {
  ROUND_UP = 'round_up',
  SUBSCRIPTION = 'subscription',
  ROUND_UP_SUBSCRIPTION = 'round_up_subscription',
}

export type MultiLingualField = {
  'en': string;
  'fr'?: string;
  'es'?: string;
  'de'?: string;
  'it'?: string;
}

export type Coordinates = {
  latitude: number;
  longitude: number;
}
